import React from "react"
// import styles from "../App.module.css"

const BPMName = props => {
  let arrayName = [
    "Larghissimo",
    "Grave",
    "Lento",
    "Largo",
    "Larghetto",
    "Adagio",
    "Adagietto",
    "Andante Moderato",
    "Andante",
    "Andantino",
    "Marcia Moderato",
    "Moderato",
    "Allegretto",
    "Allegro",
    "Vivace",
    "Vivacissimo",
    "Allegrissimo",
    "Presto",
    "Prestissimo"
  ]

  let arr = []

  for (const i of arrayName) {
    arr.push(
      <option key={i} value={i}>
        {i}
      </option>
    )
  }

  return (
    <select className={props.skin} value={props.bpmname} disabled>
      {arr}
    </select>
  )
}

export default BPMName
